import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { faTimesSquare, faCheckSquare } from '@fortawesome/pro-light-svg-icons';
import { ProColumns } from '@ant-design/pro-table';
import { useDispatch, useSelector } from 'react-redux';
import { loadPacientesWorkspace } from '../../../../state/actions/creators/pacientes.actioncreator';
import FiltrableProTable from '../../../shared/containers/FiltrableProTable';
import { Box, Text } from '../../../shared/components';
import FormPatientList from './formPatientList';
import HeaderTitlePatientList from './headerTitlePatientList';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';

export default function TablePatientList({ rowClick, pageSize }:any) {
  const tiendaId = useSelector((state: any) => state.auth.user.user_info.tienda_id);
  const {
    pacientes, loadingPacientes, totalPacientes, keyword,
  } = useSelector((state: any) => state.pacientesWorkspace);
  const dispatch = useDispatch();
  const permisos = useSelector((state: any) => state.auth.permisos.permiso);
  const oldKeywordState = useSelector((state: any) => state.pacientesWorkspace.oldKeyword);

  const actualPage = useSelector((state: any) => state.pacientesWorkspace.page);
  const actualSorter = useSelector((state: any) => state.pacientesWorkspace.sorter);
  const actualTiendaId = useSelector((state: any) => state.pacientesWorkspace.tiendaId);

  const [filterTienda] = useState<string>(permisos.acceso_paciente_otra_tienda === 'T' ? 'All' : actualTiendaId);
  const [filterSorter, setFilterSorter] = useState<any>(actualSorter);
  const [currentPage, setCurrentPage] = useState<number>(actualPage);
  useEffect(() => { setCurrentPage(actualPage)}, [actualPage] );
  const { isTablet } = useBreakpoint();

  const columns: ProColumns[] = [
    {
      title: (<Text
        translationId="pacientes.id"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'id',
      align: 'right',
      defaultSortOrder: 'descend',
      hideInTable: isTablet,
    },
    {
      title: (<Text
        translationId="pacientes.generic.params.nombre_1"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'nombre_1',
      renderText: (text: any, record: any) => `${text} ${record.nombre_2 ? record.nombre_2 : ''}`,
    },
    {
      title: (<Text
        translationId="pacientes.generic.params.apellidos"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'apellido_1',
      renderText: (text: any, record: any) => `${text || '-'} ${record.apellido_2 ? record.apellido_2 : ''}`,
    },
    {
      title: (<Text
        translationId="generico.nif"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'documento_identidad',
      align: 'right',
      hideInTable: isTablet,
    },
    {
      title: (<Text
        translationId="generico.tienda"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'nombre_sucursal',
      hideInTable: isTablet,
    },
    {
      title: (<Text
        translationId="pacientes.generic.titles.telefono_1"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'telefono_1',
      align: 'right',
      hideInTable: isTablet,
    },
    {
      title: (<Text
        translationId="pacientes.generic.titles.movil"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'movil',
      align: 'right',
    },
    {
      title: (<Text
        translationId="pacientes.generic.titles.email"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'email',
      hideInTable: isTablet,
    },
    {
      title: (<Text
        translationId="pacientes.generic.params.nacimiento"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'fecha_nacimiento',
      renderText: (text:any, record:any) => {
        if(record.fecha_nacimiento != null) return record.fecha_nacimiento.split(' ')[0];
      },
      align: 'center',
      hideInTable: isTablet,
    },
    {
      title: (<Text
        translationId="pacientes.generic.params.ult_compra"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'fecha_ultimo_encargo',
      renderText: (text:any, record:any) => {
        if(record.fecha_ultimo_encargo != null) return record.fecha_ultimo_encargo.split(' ')[0];
      },
      align: 'center',
      hideInTable: isTablet,
    },
    {
      title: (<Text
        translationId="pacientes.generic.params.grad"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'fecha_ultima_gradopt',
      renderText: (text: any, record: any) => {
        if (record.fecha_ultima_gradcontac && record.fecha_ultima_gradopt) return 'Opt. / Con.';
        if (record.fecha_ultima_gradcontac) return 'Con.';
        if (record.fecha_ultima_gradopt) return 'Opt.';
        return '';
      },
    },
    {
      title: (<Text
        translationId="pacientes.generic.params.rgpd"
        upperCase={undefined}
        lowerCase={undefined}
        children={undefined}
        fontSize="16px"
        fontWeight="600"
        fontFamily="'Open Sans', sans-serif"
      />),
      dataIndex: 'rgpd_firmada',
      render: (text: any, record: any) => (
        <FontAwesomeIcon
          color={record.rgpd_firmada === true ? 'green' : 'red'}
          icon={record.rgpd_firmada === true ? faCheckSquare : faTimesSquare}
        />
      ),
      align: 'center',
    },
  ];
  const pagination = {
    showSizeChanger: false,
    showTotal: undefined,
    pageSize,
    total: totalPacientes,
    current: currentPage,
  };
  // @ts-ignore
  const handleTableChange = ({ current: page }, filters, sorter) => {
    setCurrentPage(page);
    setFilterSorter(sorter);
    if (filterTienda != 'All') {
      dispatch(loadPacientesWorkspace({
        tiendaId: filterTienda, keyword, page: page, pageSize, sorter: filterSorter
      }));
    } else {
      dispatch(loadPacientesWorkspace({
        tiendaId: -1, keyword, page: page, pageSize, sorter: filterSorter
      }));
    }
  };

  const reloadPage = () => {
    sessionStorage.removeItem('payloadGetPacientes');
    dispatch(loadPacientesWorkspace({
      tiendaId: filterTienda !== 'All' ? filterTienda : -1, keyword, page: currentPage, pageSize, sorter: filterSorter
    }));
  };
  const setCurrentPageFunc = (page: number) => {
    setCurrentPage(page);
  }
  return (
    <FiltrableProTable
      columns={columns}
      datasource={pacientes}
      rowClick={rowClick}
      pagination={pagination}
      loading={loadingPacientes}
      expandedRowRender={false}
      onChange={handleTableChange}
      reload={reloadPage}
      headerTitle={(
        <HeaderTitlePatientList totalPacientes={totalPacientes} />
      )}
      density
      setting
      form={(
        <FormPatientList pageSize={20} filterTienda={filterTienda} filterKeyword={keyword} onPageChange={setCurrentPageFunc} />
      )}
    />
  );
}
